import { stretchGoalTargetTypes } from '@/Models';
import { calculatePercentage } from '@/Utils/MathUtility';
import Resources from '@/Resources.js';
import Formatter from '@/Utils/Formatter';

export function updateStretchGoalsProgress(stretchGoals, fundsGathered, backersCount, campaignDay) {
    const goals = [...stretchGoals];
    goals.forEach(stretchGoal => {
        switch (stretchGoal.targetType) {
        case stretchGoalTargetTypes.backersCount:
            stretchGoal.value = Math.min(stretchGoal.targetValue, backersCount);
            break;
        case stretchGoalTargetTypes.backedFunds:
            stretchGoal.value = Math.min(stretchGoal.targetValue, fundsGathered);
            break;
        case stretchGoalTargetTypes.campaignDay:
            stretchGoal.value = Math.min(stretchGoal.targetValue, campaignDay);
            break;
        default:
            break;
        }

        stretchGoal.progress = stretchGoal.value / stretchGoal.targetValue;
    });

    return goals;
}

export function unlockStretchGoalsStates(stretchGoals, newlyUnlockedStretchGoals) {
    const goals = [...stretchGoals];

    if (newlyUnlockedStretchGoals) {
        newlyUnlockedStretchGoals.forEach(unlockModel => {
            const stretchGoal = goals.find(c => c.projectStretchGoalID === unlockModel.projectStretchGoalID);
            stretchGoal.isUnlocked = true;
            stretchGoal.unlockedAt = unlockModel.unlockedAt;
        });
    }

    return goals;
}

export function resolveStatusText(stretchGoal, currencySymbol = null, currencyFactor = 1) {
    switch (stretchGoal.targetType) {
    case stretchGoalTargetTypes.backersCount:
        return Resources.format(Resources.ProjectHome.ProjectStretchGoalUnlocksByBackerCount, Formatter.format(stretchGoal.targetValue));
    case stretchGoalTargetTypes.backedFunds:
        return Resources.format(Resources.ProjectHome.ProjectStretchGoalUnlocksByPledgeValue, Formatter.format(stretchGoal.targetValue / currencyFactor, 'C0', currencySymbol));
    case stretchGoalTargetTypes.campaignDay:
        return Resources.format(Resources.ProjectHome.ProjectStretchGoalUnlocksByDay, Formatter.format(stretchGoal.targetValue));
    default:
        return `${ Formatter.format(stretchGoal.targetValue) } ${ stretchGoal.targetTypeName }`;
    }
}

export function resolveProgress(stretchGoal, currencySymbol = null, currencyFactor = 1) {
    const targetValueRemaining = stretchGoal.targetValue - stretchGoal.value;
    switch (stretchGoal.targetType) {
    case stretchGoalTargetTypes.backersCount:
        return Resources.format(Resources.ProjectHome.ProjectStretchGoalProgressBackerCount, Resources.pluralize(targetValueRemaining, Resources.ProjectHome.ProjectSummaryProgressPluralizedBacker));
    case stretchGoalTargetTypes.backedFunds:
        return Resources.format(Resources.ProjectHome.ProjectStretchGoalProgressPledgeValue, Formatter.format(targetValueRemaining / currencyFactor, 'C0', currencySymbol));
    case stretchGoalTargetTypes.campaignDay:
        return Resources.format(Resources.ProjectHome.ProjectStretchGoalProgressCampaignDay, targetValueRemaining, Resources.pluralize(targetValueRemaining, Resources.ProjectHome.HumanizeDatePluralizedDay));
    default:
        return `${ Math.floor(calculatePercentage(stretchGoal.value, stretchGoal.targetValue)) }% completed`;
    }
}

export function resolveDescription(stretchGoal, currencySymbol = null, currencyFactor = 1) {
    switch (stretchGoal.targetType) {
    case stretchGoalTargetTypes.backersCount:
        return stretchGoal.isUnlocked
            ? Resources.format(Resources.ProjectHome.ProjectStretchGoalBackersCountUnlockedDescription, Resources.pluralize(stretchGoal.targetValue, Resources.ProjectHome.ProjectSummaryProgressPluralizedBacker))
            : Resources.format(Resources.ProjectHome.ProjectStretchGoalBackersCountNotUnlockedDescription, Resources.pluralize(stretchGoal.targetValue, Resources.ProjectHome.ProjectSummaryProgressPluralizedBacker));
    case stretchGoalTargetTypes.backedFunds:
        return stretchGoal.isUnlocked
            ? Resources.format(Resources.ProjectHome.ProjectStretchGoalPledgeValueUnlockedDescription, Formatter.format(stretchGoal.targetValue / currencyFactor, 'C0', currencySymbol))
            : Resources.format(Resources.ProjectHome.ProjectStretchGoalPledgeValueNotUnlockedDescription, Formatter.format(stretchGoal.targetValue / currencyFactor, 'C0', currencySymbol));
    case stretchGoalTargetTypes.campaignDay:
        return stretchGoal.isUnlocked
            ? Resources.format(Resources.ProjectHome.ProjectStretchGoalCampaignDayUnlockedDescription, stretchGoal.targetValue)
            : Resources.format(Resources.ProjectHome.ProjectStretchGoalCampaignDayNotUnlockedDescription, stretchGoal.targetValue);
    default:
        return stretchGoal.targetDescription;
    }
}